import "./CallDetails.css";
const UnblockReportSection = ({
  data,
  formatEnteredDate,
  glid,
  reason,
  setGlid,
  setReason,
  handleUnBlock,
  empid_array,
  employeeDetails,
}) => {
  return (
    <>
      <div className="glid-form">
        <label htmlFor="glid">Enter GLID</label>
        <input
          type="text"
          id="glid"
          value={glid}
          placeholder="Enter GLID"
          onChange={(e) => setGlid(e.target.value)}
        />

        <label htmlFor="reason">Reason</label>
        <input
          type="text"
          id="reason"
          value={reason}
          placeholder="Enter Reason"
          onChange={(e) => setReason(e.target.value)}
        />

        <button
          type="button"
          onClick={handleUnBlock}
          disabled={!empid_array.includes(employeeDetails?.empid)}
        >
          Submit
        </button>
      </div>

      {/* --- Show table only after data is fetched --- */}
      {data && data.length > 0 && (
        <div
          className="custom-container spam-records"
          style={{ borderColor: "inherit" }}
        >
          <table
            className="custom-table table-sec"
            style={{ borderCollapse: "collapse" }}
          >
            <thead>
              <tr>
                <th>GLID</th>
                <th>Unblock Date</th>
                <th>Unblock By</th>
              </tr>
            </thead>
            <tbody>
              {data.map((details, index) => (
                <tr key={index}>
                  <th>{details?.fk_glusr_usr_id}</th>
                  <th>{formatEnteredDate(details?.entered_date)}</th>
                  <th>{details?.updated_by_empid}</th>
                </tr>
              ))}
            </tbody>
          </table>
        </div>
      )}
    </>
  );
};

export default UnblockReportSection;